import { createAction, props } from '@ngrx/store';

import { Certification } from '@cpd-app/core-module/models';

export const loadCertifications = createAction(
  '[Certification/API] Load Certifications'
);

export const certificationsLoadedSuccess = createAction(
  '[Certification/API] Certifications Loaded Success',
  props<{ certifications: Certification[] }>()
);

export const certificationsLoadedFailure = createAction(
  '[Certification/API] Certifications Loaded Failure',
  props<{ error: any }>()
);

export const clearCertifications = createAction(
  '[Certification/API] Clear Certifications'
);
